import { FormDataItem } from "../types/SurveyTypes";

// utils/validateSection.ts
export const validateSection = (
  currentSection: number,
  questionSections: number[][],
  formdata: FormDataItem[],
  answer?: Record<string, string | string[]>,
  selectedOptions?: Record<string, string[]>,
  setGoToNextSection?: React.Dispatch<React.SetStateAction<boolean>>
) => {
  if (questionSections?.length > 0) {
    for (let i = 0; i < questionSections[currentSection]?.length; i++) {
      const question = formdata[questionSections[currentSection][i] - 1];

      if (!question?.required) {
        setGoToNextSection(true);
        continue;
      }

      if (question?.type === "USER_INPUT_MULTI_CHOICE") {
        if (selectedOptions[question?.actionId]?.length > 0) {
          setGoToNextSection(true);
        } else {
          setGoToNextSection(false);
          break;
        }
      } else if (question?.type === "USER_INPUT_SINGLE_CHOICE") {
        if (answer[question?.actionId]?.length > 0) {
          setGoToNextSection(true);
        } else {
          setGoToNextSection(false);
          break;
        }
      } else if (question?.type === "RATING") {
        if (answer[question?.actionId]?.length > 0) {
          setGoToNextSection(true);
        } else {
          setGoToNextSection(false);
          break;
        }
      } else if (answer[question?.actionId]?.length > 0) {
        setGoToNextSection(true);
      } else {
        setGoToNextSection(false);
        break;
      }
    }
  }
};
